import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import '../Style/main.css'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import illustrateImage from '../Images/Illustrator.svg'
import bg1 from '../Images/bg1.png'
import bg2 from '../Images/bg2.png'
import logo from '../Images/logo.png'
import { givePrice } from '../Http/ApiCalls'
import BounceLoader from 'react-spinners/BounceLoader'
import { useTranslation } from 'react-i18next'

const Home = () => {
    const { i18n } = useTranslation()
    const { t } = useTranslation()
    const [selectedLanguage, setSelectedLanguage] = useState(i18n.language)
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)
    const [values, setValues] = useState({
        userName: '',
        city: ''
    })

    const override = {
        display: 'block',
        margin: ' 400px auto',
        borderColor: 'red'
    }

    const changeLanguage = (language) => {
        i18n.changeLanguage(language)
        setSelectedLanguage(language)
    }

    const { userName, city } = values

    const handleChange = (item) => (event) => {
        const value = event.target.value
        setValues({ ...values, [item]: value })
    }

    const submitHandler = (event) => {
        event.preventDefault()
        setLoading(true)
        givePrice(userName, city)
            .then((user) => {
                setLoading(false)
                navigate('/survey', {
                    state: {
                        userData: user.data
                    }
                })
            })
            .catch((err) => {
                setLoading(false)
                toast(err.data.message, {
                    position: 'top-right',
                    autoClose: 3000,
                    type: 'error',
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: 'light'
                })
            })
    }

    return (
        <div className="surveyPage container-fluid">
            {loading ? (
                <>
                    <BounceLoader
                        color={'#120E43'}
                        loading={true}
                        size={60}
                        cssOverride={override}
                    />
                </>
            ) : (
                <>
                    <div className="languageOptions">
                        <button
                            onClick={() => changeLanguage('en')}
                            className={selectedLanguage === 'en' ? 'active' : ''}>
                            English
                        </button>
                        <button
                            onClick={() => changeLanguage('hi')}
                            className={selectedLanguage === 'hi' ? 'active' : ''}>
                            हिन्दी
                        </button>
                    </div>
                    <div className="row">
                        <div className="col-12 col-5 col-lg-5">
                            <div className="leftSide">
                                <div className="header">
                                    <img
                                        src={logo}
                                        alt="bglogo"
                                        id="logo"
                                        className="img-fluid"
                                    />
                                </div>

                                <img
                                    src={bg2}
                                    alt="background"
                                    id="bgImage2"
                                    className="img-fluid"
                                />
                                <img
                                    src={illustrateImage}
                                    alt="Illustateimage"
                                    id="mainImage"
                                    className="img-fluid"
                                />
                                <img
                                    src={bg1}
                                    alt=""
                                    id="bgImage1"
                                    className="img-fluid"
                                />
                            </div>
                        </div>
                        <div className="col-7 col-lg-7 col-12">
                            <div className="rightSide">
                                <h5>{t('greeting')}</h5>
                                <p>{t('description')}</p>
                                <form onSubmit={submitHandler}>
                                    <label htmlFor="userName">{t('usernameLabel')}</label>
                                    <input
                                        type="text"
                                        id="userName"
                                        onChange={handleChange('userName')}
                                        required
                                        placeholder={t('usernamePlaceholder')}
                                    />
                                    <label htmlFor="userCity">{t('userCityLabel')}</label>
                                    <input
                                        type="text"
                                        id="userCity"
                                        onChange={handleChange('city')}
                                        required
                                        placeholder={t('cityPlaceholder')}
                                    />
                                    <br />
                                    <button type="submit">{t('submitBtn')}</button>
                                </form>
                            </div>
                        </div>
                    </div>
                </>
            )}

            <ToastContainer />
        </div>
    )
}

export default Home
